/**
 * PmViewerTour (iter150AZ.42) — coachmark walkthrough for the
 * Compressor PM viewer modal (CompressorPmViewerModal):
 *
 *   1. Title + serial header
 *   2. Schedule tab vs Service Parts Chart tab
 *   3. Stock column
 *   4. Red MISSING badge
 *   5. "+ Quote" affordance per hour-column
 *   6. PDF download (with embedded QR codes)
 *
 * Auto-runs the first time the user opens the modal; the Help "?"
 * button can re-launch it any time.
 */
import { useState } from "react";
import { useT } from "@/lib/i18n";
import GuidedTour, { TourHelpButton } from "@/components/GuidedTour";

const STORAGE_KEY = "tour_pm_viewer_v1";

function buildSteps(t) {
  return [
    {
      target: '[data-tour="pm-header"]',
      content: t("tour.pm.header",
        "Welcome to the PM viewer. Everything for this compressor's preventive-maintenance lifecycle lives here."),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="pm-tabs"]',
      content: t("tour.pm.tabs",
        "Two views: Schedule lists upcoming PMs grouped by urgency. Service Parts Chart pivots them by hour-interval."),
      placement: "bottom",
    },
    {
      target: '[data-testid="pm-viewer-pdf-download"]',
      content: t("tour.pm.pdf",
        "Download the schedule + parts chart + every linked invoice as one PDF. Each invoice page has a QR code linking back to the live quote."),
      placement: "bottom",
    },
    {
      target: '[data-tour="pm-pivot-stock"]',
      content: t("tour.pm.stock",
        "Stock column — on-hand inventory. Cells fulfilled from stock are highlighted amber."),
      placement: "right",
    },
    {
      target: '[data-tour="pm-pivot-missing"]',
      content: t("tour.pm.missing",
        "Red MISSING cells are PM parts not yet purchased or in stock. These are the ones you need to quote."),
      placement: "top",
    },
    {
      target: '[data-tour="pm-pivot-quote-btn"]',
      content: t("tour.pm.quote_btn",
        "Click + Quote on any hour-column to auto-generate a draft PM quote — it only includes the MISSING parts for that interval."),
      placement: "bottom",
    },
  ];
}

export default function PmViewerTour({ runFlag, onFinish }) {
  const t = useT();
  const [steps] = useState(() => buildSteps(t));
  return <GuidedTour steps={steps} storageKey={STORAGE_KEY}
                     runFlag={runFlag} onFinish={onFinish} />;
}

export { TourHelpButton };
